import React from 'react';
import SideNavBar from '../../components/headers/sidenavbar/SideNavBar';
import UserData from '../../components/headers/topnavbar/UserData';
import StartCoursesChild from '../../components/courseschild/StartCoursesChild';

export default function StartCourse() {
    return (
        <>
            <div id="wrapper">
                <SideNavBar />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <UserData />
                        <div className="container-fluid">
                            <StartCoursesChild />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
